module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header hide\" xmlns=\"http://www.w3.org/1999/html\"><span class=\"prop-label\">Table Column Settings</span></div>\r\n<div id=\"propColumnHeader\" class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-65\">Header</label> \r\n        <div style=\"display: inline-flex;\">\r\n            <input type=\"text\" name=\"header\" class=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.header !== '' ? 'translatable' : '' ))
    ; __append("\" data-attr=\"header\" value=\"")
    ; __append(escapeFn(gridData[selectedRowId].attributes.header))
    ; __append("\"  />\r\n        </div>   \r\n    </div> \r\n</div>\r\n\r\n<div id=\"propColumnWidth\" class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-65\">Width</label> \r\n        <div>\r\n            <input type=\"text\" name=\"width\" value=\"")
    ; __append(escapeFn(gridData[selectedRowId].attributes.width))
    ; __append("\" style=\"width:45px;\"/> px\r\n        </div>   \r\n    </div>  \r\n</div>\r\n\r\n<div id=\"column-footer-row-prop\" class=\"row hide\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-65\">Footer Row</label> \r\n        <div>\r\n            <select id=\"table-column-footer-prop\" name=\"footerfun\"  >\r\n                <option value=\"None\">None</option>\r\n                <option value=\"Sum\">Sum</option>\r\n                <option value=\"Average\">Average</option>\r\n            </select>\r\n        </div>   \r\n    </div>\r\n</div>")
  }
  return __output;

}